import { numberFormat } from "@/helper/format-data";

export const TotalAreaDisplay = ({ totalArea }: { totalArea: number }) => {
  if (totalArea < 100_000) {
    return (
      <span className="text-3xl font-bold">
        {numberFormat(totalArea)} m<sup>2</sup>
      </span>
    );
  }
  return (
    <span className="text-3xl font-bold">
      {numberFormat(totalArea / 1_000_000)} km<sup>2</sup>
    </span>
  );
};
